(() => {
  const AVAILABILITY_PARAM = 'filter.v.availability';
  const FILTER_PREFIX = 'filter.';

  const hasActiveFilters = (params) =>
    Array.from(params.keys()).some(
      (key) => key.startsWith(FILTER_PREFIX) && key !== AVAILABILITY_PARAM
    );

  document.addEventListener(
    'facet:update',
    (event) => {
      const { url } = event.detail;

      if (hasActiveFilters(url.searchParams)) {
        url.searchParams.set(AVAILABILITY_PARAM, '1');
      } else {
        url.searchParams.delete(AVAILABILITY_PARAM);
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);

    if (hasActiveFilters(params) && !params.has(AVAILABILITY_PARAM)) {
      params.set(AVAILABILITY_PARAM, '1');
      window.location.replace(`${window.location.pathname}?${params}`);
    }
  });
})();
